/**************
 Cart
 ***************/

const cartContent = document.querySelector("#miniCartContent");
const cartEmpty = document.querySelector("#miniCartEmpty");
const cartHeader = document.querySelector("#miniCartHeader");
const cartBody = document.querySelector("#miniCartBody");
const cartUpsell = document.querySelector("#miniCartUpsell");
const cartBundle = document.querySelector("#miniCartBundle");
const cartFooter = document.querySelector("#miniCartFooter");

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    cartContent.classList.add("loading");

    // hide empty cart section
    cartEmpty.classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());

    // stop loading animation
    cartContent.classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('.headerIconsItemCount').textContent = `${cart.item_count}`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        cartEmpty.classList.add("active");
        cartHeader.classList.remove("active");
        cartBody.classList.remove("active");
        cartUpsell.classList.remove("active");
        cartBundle.classList.remove("active");
        cartFooter.classList.remove("active");
        return;
    }

    // show main cart sections
    cartHeader.classList.add("active");
    cartBody.classList.add("active");
    cartUpsell.classList.add("active");
    cartFooter.classList.add("active");

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    //mark for footer pricing message
    let freeShipping = false;

    // Free shipping for subscription
    if (cartSettings.free_shipping_method === "subscription") {
        if (subscriptionItems > 0) {
            document.querySelector("#miniCartHeaderShipping").textContent = "You've unlocked FREE SHIPPING";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
            freeShipping = true;
        } else {
            document.querySelector("#miniCartHeaderShipping").textContent = "Upgrade to a subscription for FREE SHIPPING";
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // Free shipping for price threshold
    if (cartSettings.free_shipping_method === "threshold") {
        let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
        if (cart.total_price >= freeShippingThreshold) {
            document.querySelector("#miniCartHeaderShipping").textContent = "You've unlocked FREE SHIPPING";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
            freeShipping = true;
        } else {
            document.querySelector("#miniCartHeaderShipping").textContent = `${price(freeShippingThreshold - cart.total_price)} away to unlock FREE SHIPPING`;
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        // save supplement data
        const supplementData = cartData.variantIdInformation[item.key] || {};

        // determine if item has properties
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // if bogo skip
                if (key.includes("bogos") || key.includes("__") || key.includes("_") || key.includes("isTrusted")) continue;

                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = price(item.final_line_price);

            // there are 3 types of compare at prices (selling_plan_allocation, line item discount, compare at price)
            // calculate all 3 and the greatest one will be displayed if it is greater than the final line price
            const comparePrices = [];

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrices.push(item.selling_plan_allocation.compare_at_price * item.quantity);
            }

            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrices.push(item.original_line_price);
            }

            // check for compare at price
            if (supplementData.compare_at_price) {
                comparePrices.push(supplementData.compare_at_price * item.quantity);
            }

            // if there is at least one compare price
            if (comparePrices.length > 0) {
                // find the greatest compare price
                const greatestComparePrice = Math.max(...comparePrices);

                // check if the greatest compare price is greater than the final line price
                if (greatestComparePrice > item.final_line_price) {
                    HTML += `
                        <span><s>${price(greatestComparePrice)}</s></span>
                    `;
                }
            }

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {

            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // check if selling plan exists
            if (!supplementData["selling_plan_id"]) {
                return "";
            }

            // return HTML
            return `
                <button class="miniCartBodyItemUpgrade button" data-plan="${supplementData["selling_plan_id"]}">
               ${supplementData["selling_plan_name"]}
                </button>
            `;
        }

        // insert item
        cartBody.insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <div class="miniCartBodyItemInner">
                    <a href="${item.url}" aria-label="link to ${item.product_title}">
                        <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                    </a>
                    <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemFlexInner">
                            <a href="${item.url}" class="miniCartBodyItemVendor">${item.vendor}</a>
                            <a href="${item.url}" class="miniCartBodyItemTitle">${item.product_title}</a>
                            ${variantHTML()}
                            ${propertiesHTML()}
                            ${subscriptionHTML()}
                            <div class="miniCartBodyItemQuantity">
                                <button class="miniCartBodyItemQuantityMinus" type="button" aria-label="decrease item quantity">-</button>
                                <input class="miniCartBodyItemQuantityCount" type="number" aria-label="quantity" name="${item.product_title} quantity" value="${item.quantity}">
                                <button class="miniCartBodyItemQuantityPlus" type="button" aria-label="increase item quantity">+</button>
                            </div>
                        </div>
                        <div class="miniCartBodyItemFlexInner">
                            <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                            <button class="miniCartBodyItemRemove" type="button" aria-label="remove item from cart">
                                <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                  <g clip-path="url(#clip0_1810_4679)">
                                    <path d="M18.5175 4.74H1.48248C1.06748 4.74 0.72998 4.4025 0.72998 3.9875C0.72998 3.5725 1.06748 3.235 1.48248 3.235H18.5175C18.9325 3.235 19.27 3.5725 19.27 3.9875C19.27 4.4025 18.9325 4.74 18.5175 4.74Z" fill="#202020"/>
                                    <path d="M10.3876 19.77H9.61256C6.84256 19.77 5.31756 19.77 4.23256 18.7575C3.15006 17.745 3.04756 16.2225 2.86256 13.4575L2.40256 6.545C2.37506 6.13 2.68756 5.7725 3.10256 5.745C3.51756 5.7175 3.87506 6.03 3.90256 6.445L4.36256 13.3575C4.52756 15.8175 4.61006 17.0525 5.26006 17.66C5.91006 18.2675 7.14756 18.2675 9.61256 18.2675H10.3876C12.8526 18.2675 14.0901 18.2675 14.7401 17.66C15.3901 17.0525 15.4726 15.8175 15.6376 13.3575L16.0976 6.445C16.1251 6.03 16.4851 5.7175 16.8976 5.745C17.3126 5.7725 17.6251 6.13 17.5976 6.545L17.1376 13.4575C16.9526 16.2225 16.8526 17.745 15.7676 18.7575C14.6851 19.77 13.1576 19.77 10.3876 19.77Z" fill="#202020"/>
                                    <path d="M7.99514 14.76C7.61264 14.76 7.28764 14.47 7.24764 14.0825L6.74764 9.0725C6.70514 8.66 7.00764 8.29 7.42014 8.25C7.83264 8.2075 8.20264 8.51 8.24264 8.9225L8.74264 13.9325C8.78514 14.345 8.48264 14.715 8.07014 14.755C8.04514 14.7575 8.02014 14.76 7.99514 14.76Z" fill="#202020"/>
                                    <path d="M12.0049 14.76C11.9799 14.76 11.9549 14.76 11.9299 14.755C11.5174 14.7125 11.2149 14.345 11.2574 13.9325L11.7574 8.9225C11.7999 8.51 12.1674 8.2075 12.5799 8.25C12.9924 8.2925 13.2949 8.66 13.2524 9.0725L12.7524 14.0825C12.7124 14.47 12.3874 14.76 12.0049 14.76Z" fill="#202020"/>
                                    <path d="M15.5127 4.74C15.4477 4.74 15.4152 4.74 15.3852 4.74C14.8277 4.725 14.2952 4.5475 13.8427 4.22C13.3902 3.895 13.0527 3.445 12.8627 2.9225C12.8527 2.895 12.8427 2.8625 12.8202 2.8L12.7227 2.5075C12.6577 2.315 12.6177 2.19 12.5902 2.1375C12.4802 1.9275 12.2752 1.78 12.0427 1.7425C11.9827 1.7325 11.8502 1.7325 11.6502 1.7325H8.35518C8.15268 1.7325 8.02018 1.7325 7.96268 1.7425C7.72768 1.78 7.52518 1.9275 7.41518 2.1375C7.38768 2.19 7.34518 2.3175 7.28268 2.5075L7.18518 2.8C7.16518 2.8625 7.15268 2.8925 7.14268 2.9225C6.95268 3.445 6.61518 3.895 6.16268 4.22C5.71018 4.545 5.17768 4.725 4.62018 4.74C4.59018 4.74 4.55768 4.74 4.49268 4.74V3.2375C4.53768 3.2375 4.56268 3.2375 4.58268 3.2375C5.10268 3.225 5.55268 2.9 5.72768 2.4125C5.73518 2.3925 5.74268 2.37 5.75768 2.3275L5.85518 2.035C5.94768 1.7575 5.99768 1.605 6.08018 1.445C6.40768 0.814998 7.02268 0.372498 7.72518 0.259998C7.90268 0.232498 8.06268 0.232498 8.35518 0.232498H11.6502C11.9427 0.232498 12.1027 0.232498 12.2802 0.259998C12.9827 0.372498 13.5952 0.814998 13.9252 1.445C14.0077 1.6025 14.0577 1.755 14.1502 2.0325L14.2477 2.3275C14.2627 2.3725 14.2702 2.3925 14.2777 2.4125C14.4552 2.9 14.9052 3.225 15.4227 3.2375C15.4427 3.2375 15.4677 3.2375 15.5127 3.2375V4.74Z" fill="#202020"/>
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1810_4679">
                                      <rect width="20" height="20" fill="white"/>
                                    </clipPath>
                                  </defs>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                ${upgradeHTML()}
            </div>
        `);

    });

    // add blur event on all quantity inputs
    document.querySelectorAll(".miniCartBodyItemQuantityCount").forEach(count => {
        count.addEventListener("change", function () {
            const item = this.closest(".miniCartBodyItem");
            const key = item.dataset.key;
            const quantity = this.value || 0;
            updateCartItem(item, key, quantity);
        });
    })

    // clear cart display of dynamically added items
    document.querySelectorAll('.miniCartUpsellItem.productUpsell,.miniCartBundleItem')?.forEach(el => {
        el.removeEventListener('click', upsellAtc);
        el.remove();
    })

    // add metafield upsell items
    const upsells = []
    for (const value of Object.values(cartData.variantIdInformation)) {
        if (value.upsell_product) {
            upsells.push(`
                    <div class="miniCartUpsellItem productUpsell miniCartAdditional"
             data-product="${value.upsell_product.id}"
             data-variant="${value.upsell_product.variant_id}">
            <img class="miniCartUpsellItemImg"
                 src="${value.upsell_product.image}"
                 alt="${value.upsell_product.title}">
            <div class="miniCartUpsellItemBody">
                <div class="miniCartUpsellItemBodyTop">
                    <div>
                        <div class="miniCartUpsellItemBodyVendor">${value.upsell_product.vendor}</div>
                        <div class="miniCartUpsellItemBodyTitle">${value.upsell_product.title}</div>
                    </div>
                    <div class="miniCartUpsellItemBodyPrice">
                        <span>${price(value.upsell_product.price)}</span>
                        <s>${value.upsell_product.compare_price > value.upsell_product.price ? price(value.upsell_product.compare_price) : ""}</s>
                    </div>
                </div>
                <button class="miniCartUpsellItemATC miniCartButton" 
                title="add to order" aria-label="Add to Order">
                    Add to Order
                </button>
            </div>

        </div>
            `)
        }
    }

    if (upsells.length > 0) {
        // add to cart display
        document.querySelector("#miniCartUpsellInner").insertAdjacentHTML("beforeend", upsells.join(""));
        // add the function for atc
        document.querySelectorAll('.miniCartUpsellItem.productUpsell .miniCartUpsellItemATC').forEach(function (element) {
            element.addEventListener("click", () => upsellAtc(element));
        });
    }

    // check if cart contains an upsell item, block and meta
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        cartUpsell.classList.remove("active");
    }

    // add metafield bundle items
    const bundleItems = [];
    // gather ids in case some share item and skip
    const bundleIds = [];
    for (const value of Object.values(cartData.variantIdInformation)) {
        if (value.bundle_product) {
            // check if already added and add id
            if (bundleIds.includes(value.bundle_product.variant_id)) continue;
            bundleIds.push(value.bundle_product.variant_id);
            // check if in the cart
            if (!cart.items.find(item => item.variant_id === value.bundle_product.variant_id)) {
                bundleItems.push(`
            <div class="miniCartBundleItem miniCartAdditional"
             data-variant="${value.bundle_product.variant_id}">
                <div class="miniCartBundleTitle">${value.bundle_product.title}</div>
                <div class="miniCartBundleText">${value.bundle_product.text}</div>
                <div class="miniCartBundleBottom">
                    <img class="miniCartBundleBottomImg"
                         src="${value.bundle_product.image}"
                         alt="${value.bundle_product.title}">
                    <button class="miniCartBundleBottomATC miniCartButton" 
                    title="add to order" aria-label="Add to Order">
                        Add to Order
                    </button>
                </div>
            </div>
            `)
            }
        }
    }

    if (bundleItems.length > 0) {
        // add to cart display
        cartBundle.insertAdjacentHTML("beforeend", bundleItems.join(""));
        // add the function for atc
        document.querySelectorAll('.miniCartBundleBottomATC').forEach(function (element) {
            element.addEventListener("click", () => upsellAtc(element));
        });
        // reveal the section
        cartBundle.classList.add("active");
    }

    // update the price in the footer and the savings if applicable
    document.querySelector("#miniCartFooterPrice span").textContent = price(cart.items_subtotal_price);
    if (parseInt(cartData.totalCartCompare) > cart.items_subtotal_price) {
        document.querySelector("#miniCartFooterSavings").textContent = `You saved ${price(cartData.totalCartCompare - cart.items_subtotal_price)}${freeShipping ? " + Free Shipping" : ""}`
    } else {
        document.querySelector("#miniCartFooterSavings").textContent = "";
    }

}

// event listener for body
document.querySelector('#miniCartBody').addEventListener('click', async (e) => {

    const item = e.target.closest('.miniCartBodyItem');
    // if not an item, return
    if (!item) return;

    // get key
    let key = item.dataset.key;
    // get current quantity
    let quantity = parseInt(item.querySelector(".miniCartBodyItemQuantityCount").value);

    // minus button
    const minus = e.target.closest('.miniCartBodyItemQuantityMinus');
    if (minus) {
        if (quantity === 1) {
            item.querySelector(".miniCartBodyItemRemove").click();
        } else {
            quantity--;
            await updateCartItem(item, key, quantity);
        }
        return;
    }

    // plus button
    const plus = e.target.closest('.miniCartBodyItemQuantityPlus');
    if (plus) {
        quantity++;
        await updateCartItem(item, key, quantity);
        return;
    }

    // remove button
    const remove = e.target.closest('.miniCartBodyItemRemove');
    if (remove) {
        quantity = 0;
        await updateCartItem(item, key, quantity);
        return;
    }

    // upgrade to subscription button
    const upgrade = e.target.closest('.miniCartBodyItemUpgrade');
    if (upgrade) {
        const sellingPlanID = parseInt(upgrade.dataset.plan);

        // start loading animation
        cartContent.classList.add("loading");

        // add selling plan
        cart = await changeCart({
            id: key,
            quantity: quantity,
            selling_plan: sellingPlanID
        });

        await openCart(true);
    }
})

// update quantity function
async function updateCartItem(item, key, quantity) {
    // start loading animation
    cartContent.classList.add("loading");
    // update quantity input
    item.querySelector(`.miniCartBodyItemQuantityCount`).value = quantity;

    // update cart in shopify
    cart = await updateCart({
        updates: {
            [key]: quantity
        }
    });

    // update active body
    await openCart(true);
}

// Add Upsell function
document.querySelectorAll('.miniCartUpsellItem').forEach(function (element) {
    element.addEventListener("click", () => upsellAtc(element));
});

// upsell function
async function upsellAtc(element) {
    // get variant ID item
    const variantID = element.closest('.miniCartAdditional').dataset.variant;

    // start loading animation
    cartContent.classList.add("loading");

    // create form data
    let formData = {
        items: [{
            quantity: 1,
            id: variantID,
        }]
    };

    // add product upsell
    await addProduct(formData);

    await openCart();
}

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");
    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}